import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m18,21.8H6c-2.1,0-3.8-1.7-3.8-3.8V6c0-2.1,1.7-3.8,3.8-3.8h12c2.1,0,3.8,1.7,3.8,3.8v12c0,2.1-1.7,3.8-3.8,3.8ZM6,3.8c-1.2,0-2.2,1-2.2,2.2v12c0,1.2,1,2.2,2.2,2.2h12c1.2,0,2.2-1,2.2-2.2V6c0-1.2-1-2.2-2.2-2.2H6Z"
          stroke-width="0"
        />
        <path
          d="m14.4,13.1c0,.4.1.6.4.6.7,0,1.2-.9,1.2-2.5,0-2.4-1.7-3.5-3.9-3.5-2.1.1-4.1,1.6-4.1,4.4s1.8,4.1,4.4,4.1c.9,0,1.5-.1,2.5-.4l.2.8c-.9.3-1.9.4-2.7.4-3.5,0-5.4-1.9-5.4-4.9s2.2-5.1,5.2-5.1,4.8,1.9,4.8,4.2c0,2-.6,3.4-2.5,3.4-.9,0-1.5-.4-1.5-1.1-.2.9-.8,1.1-1.6,1.1-1.1,0-2-.8-2-2.5s.8-2.8,2.2-2.8c.8,0,1.2.3,1.4.8l.4-.7h1v3.7h0Zm-1.5-1.6c0-.7-.5-1-.9-1-.5,0-1,.4-1,1.5,0,.9.4,1.4,1,1.4.4,0,.9-.3.9-1v-.9Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
